// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2t_92","gfeWrapper":"CalendarEvent_gfeWrapper__sRKXc"};